import { $alert } from './defaultAlert'
import { $confirm } from './defaultComfirm'
import { $loading } from './appLoading'
import { matchPhone } from '@/utils/tools'

export default {
    install: function (app: any): void {
        app.config.globalProperties.$alert = $alert
        app.config.globalProperties.$confirm = $confirm
        app.config.globalProperties.$loading = $loading
        app.config.globalProperties.$phoneVersion = matchPhone()
    },
}
